// ESM-Huelle fuer lib/scripts/components/CMP_CTabbedPushPanel.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CTabbedPushPanel(id) {
	this.construct(id);

	this.name = "CTabbedPushPanel";
	this.htmlType = "span";

	this.container = null;
	this.tabs = new Array();
	this.tabsPanel = null;
	this.currentTab = null;
	this.items = new Array();
	this.itemsPanels = new Array();
	this.itemsPanelsIds = new Array();
	this.currentPanel = null;
	this.properties = {
		itemsType : "array",
		tabsType : "array",
	};

	this.setStyleFromXML();
}

CTabbedPushPanel.prototype = new CComponent;

CTabbedPushPanel.prototype.prepare = function () {

	this.tabsPanel = this.addChild(CPagedPushPanel);
	this.tabsPanel.properties.type = this.properties.tabsType;
	this.tabsPanel.buttons = this.tabs;
	
	//var colSpace = parseInt(this.properties.tabs.styles.width.replace("%", "")) / this.properties.tabs.columns;
	//var rowSpace = parseInt(this.properties.tabs.styles.height.replace("%", "")) / this.properties.tabs.rows;
	/*var rowSpace = 100 / this.properties.tabs.columns;
	var colSpace = 100 / this.properties.tabs.rows;
	this.properties.tabs.styles.width = colSpace * 0.90 + "%";
	this.properties.tabs.styles.height = rowSpace * 0.85 + "%";
	*/
	this.tabsPanel.properties = combine(this.tabsPanel.properties,
			this.properties.tabs);

	for (var i = 0; i < this.tabs.length; i++) {
		this.itemsPanels[i] = this.addChild(CPagedPushPanel);
		this.itemsPanels[i].properties.type = this.properties.itemsType;
		this.itemsPanels[i].buttons = this.items[i];
		this.itemsPanels[i].properties = combine(this.itemsPanels[i].properties,
				this.properties.items);

		if (i > 0)
			this.itemsPanels[i].properties.styles.visibility = "hidden";

		this.tabsPanel.buttons[i].properties.events.onMousedown = this.tabSelect;
		this.tabsPanel.buttons[i].properties.attributes.onMousedown_parameter_0 =
			this.id;
		this.tabsPanel.buttons[i].properties.attributes.onMousedown_parameter_1 = i;
	}

	if (i > 0) {
		this.currentPanel = this.itemsPanels[0];

		this.tabsPanel.prepare();
		this.tabsPanel.children[0].prepare();
		this.currentTab = this.tabsPanel.children[0].children[0];
  		
//		document.getElementById(this.currentTab.id).classList.add("selected");

//		this.currentTab.gfx.fx = true;
//		this.currentTab.gfx.doBackupStyles();
//		this.currentTab.properties.styles.backgroundColor = this.properties.tabs.selectedColor;
//		this.currentTab.properties.styles.borderColor = this.properties.tabs.selectedBorderColor;
	
}

	this.prepared = true;
}

CTabbedPushPanel.prototype.tabSelect = function (component, parameters) {
	var me = POS.getComponentById(parameters[0]);
	var i = parameters[1];

/*	me.currentPanel.properties.styles.visibility = "hidden";
	me.currentPanel.reStyle();
*/	document.getElementById(me.currentPanel.id).style.visibility = "hidden";
	
/*	me.itemsPanels[i].properties.styles.visibility = "visible";
	me.itemsPanels[i].reStyle();
*/
document.getElementById(me.itemsPanels[i].id).style.visibility = "initial";

	me.currentPanel = me.itemsPanels[i];

	if (me.currentTab != component) {
	
		document.getElementById(component.id).classList.add("selected");
		 document.getElementById(me.currentTab.id).classList.remove("selected");

//element.

	//component.gfx.fx = true;
		//component.gfx.doBackupStyles();
 		
	//	component.properties.styles.backgroundColor = me.properties.tabs.selectedColor;
	//	component.properties.styles.borderColor = me.properties.tabs.selectedBorderColor;
	//	component.reStyle();

//		if (me.currentTab)
//			me.currentTab.gfx.reset();
//		else
//			this.tabsPanel.children[0].gfx.reset();

		me.currentTab = component;
	}
}

CTabbedPushPanel.prototype.setEnabled = function (bool) {
	this.tabsPanel.setEnabled(bool);

	if (typeof this.currentPanel != "undefined" && this.currentPanel != null)
		this.currentPanel.setEnabled(bool);
}

export { CTabbedPushPanel };
